import React from 'react'
import ServicesInfo from '../features/Services/components/ServicesInfo';
function Services() {
  return (
    <div>
      <ServicesInfo/>
    </div>
  )
}

export default Services
